import React from "react";
import { TERTIARY } from "../../../constants";
import { getColors, getDayFormat, isStringNotNull } from "../../../utils";
import { Button } from "@dishopsaas/design-system";
import { Typography } from "@mui/material";

type CustomDayPickerInputProps = {
  value?: string;
  isValidDate: boolean;
  orderTime?: string | null;
  closed: boolean;
  onClick?: () => void;
};

export default function CustomDayPickerInput({
  value,
  isValidDate,
  orderTime,
  closed,
  onClick,
}: CustomDayPickerInputProps) {
  const colors = getColors();
  const isError = !isValidDate && !orderTime;

  return (
    <Button
      onClick={onClick}
      disabled={closed}
      colorType={TERTIARY}
      leftIcon="Calendar"
      sx={{
        width: "100%",
        justifyContent: "flex-start",
        textAlign: "left",
        minHeight: 44,
        backgroundColor: "transparent",
        border: colors.border,
        borderWidth: 1,
        borderColor: isError ? "red" : colors.border,
        "&:hover": {
          border: colors.border,
          borderWidth: 2,
          borderColor: isError ? "red" : "primary.main",
          backgroundColor: "transparent",
        },
      }}
    >
      <Typography sx={{ textTransform: "none" }}>
        {!closed && isStringNotNull(value) ? getDayFormat(value) : ""}
      </Typography>
    </Button>
  );
}
